/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-form-field-infix[_ngcontent-%COMP%]{display:block!important;width:160px!important}.date[_ngcontent-%COMP%]   .mat-form-field[_ngcontent-%COMP%]{width:300px!important}"];
export { styles as styles };
